export default __webpack_public_path__ + "static/media/a9.fffa024f.png";